import { render } from "./FaqComp.vue?vue&type=template&id=69bd6f76&scoped=true&ts=true"
import script from "./FaqComp.vue?vue&type=script&lang=ts"
export * from "./FaqComp.vue?vue&type=script&lang=ts"

import "./FaqComp.vue?vue&type=style&index=0&id=69bd6f76&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69bd6f76"]])

export default __exports__